import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSliderStore } from '../stores/sliderStore';
import { useGalleryStore } from '../stores/galleryStore';
import { useManagementStore } from '../stores/managementStore';
import { useImportantDateStore } from '../stores/importantDateStore';
import { useAlumniStore } from '../stores/alumniStore';
import { useStaffStore } from '../stores/staffStore';

// ponytail: One component, one effect — loads all public data once, skips admin routes entirely.
export default function PublicDataLoader() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname.startsWith('/admin')) return; // ponytail: admin needs none of this
    useSliderStore.getState().fetchSlides();
    useGalleryStore.getState().fetchGalleryItems();
    useManagementStore.getState().fetchMembers();
    useManagementStore.getState().fetchStats();
    useImportantDateStore.getState().fetchImportantDates();
    useStaffStore.getState().fetchStaff({ isActive: 'true', sort: 'designation-rank' });
    useAlumniStore.getState().fetchSuccessStories({ isActive: true });
    useAlumniStore.getState().fetchTestimonials({ isActive: true });
    useAlumniStore.getState().fetchStatistics({ isActive: true });
  }, []); // ponytail: [] = fire once at app boot, Zustand holds state in memory for all routes

  return null;
}
